import { useId, type ReactNode } from "react";
import { useT } from "../settings/context";
import { useDialog } from "./dialog";

/**
 * UNE BOÎTE DE DIALOGUE, POUR CE QUI NE TIENT PAS DANS LA PAGE.
 *
 * Un `<dialog>` natif ouvert par `showModal()`. La mécanique est celle de
 * `useDialog`, partagée avec `Confirm` : deux copies d'un même comportement, c'est
 * la seconde qui oublie Échap le jour où on touche à la première. Ce qui diffère
 * ici, et seulement ça, c'est le châssis : un titre, une croix, et du contenu
 * libre — `Confirm` pose une question courte, celle-ci accueille un formulaire.
 *
 * Displayed strings go through `t()`, French kept at the call site as the
 * fallback: what the site says of itself follows the language being read.
 */
export function Modal({
  open,
  title,
  onClose,
  className,
  children,
}: {
  open: boolean;
  title: string;
  onClose: () => void;
  /** One more class on the dialog, for a window that needs its own frame (`.cwpick`). */
  className?: string;
  children: ReactNode;
}) {
  const t = useT();
  const dialog = useDialog(open, onClose);
  /* ⚠️ LA BOÎTE PORTE UN NOM. Sans `aria-labelledby`, un lecteur d'écran annonce
     « dialogue » et rien d'autre : le titre est à l'écran, il n'est pas dit. */
  const titleId = useId();

  return (
    <dialog
      {...dialog}
      className={className ? `modal ${className}` : "modal"}
      aria-labelledby={titleId}
    >
      <div className="modal__b">
        <div className="modal__h">
          <b id={titleId}>{title}</b>
          <button
            type="button"
            className="modal__x"
            aria-label={t("CLOSE", "Fermer")}
            onClick={onClose}
          >
            ✕
          </button>
        </div>
        <div className="modal__c">{children}</div>
      </div>
    </dialog>
  );
}
